/**
 * Hook: useUpdatePipeline
 * Atualiza pipeline (nome, perfis que podem acessar, etc)
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Pipeline, PipelinePerfilUsuario } from '../types';

interface UpdatePipelineInput {
  id: string;
  nome?: string;
  perfil_usuario?: PipelinePerfilUsuario | PipelinePerfilUsuario[];
  tenant_ids?: number[];
  permitir_associados?: boolean;
}

export function useUpdatePipeline() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, nome, perfil_usuario, tenant_ids, permitir_associados }: UpdatePipelineInput) => {
      const updates: Record<string, any> = {};
      if (nome !== undefined) updates.nome = nome;
      if (perfil_usuario !== undefined) updates.perfil_usuario = perfil_usuario;
      if (tenant_ids !== undefined) updates.tenant_ids = tenant_ids;
      if (permitir_associados !== undefined) updates.permitir_associados = permitir_associados;

      const { data, error } = await supabase
        .from('pipelines')
        .update(updates)
        .eq('id', id)
        .select()
        .single();

      if (error) {
        throw new Error(`Erro ao atualizar pipeline: ${error.message}`);
      }

      return data as Pipeline;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pipelinesList'] });
      queryClient.invalidateQueries({ queryKey: ['pipelineBoard'] });
    }
  });
}
